/**
 * @file Video
 * @author Yu Zong(liuxuanzy@qq.com)
 */
export var PLAYER_STATUS;
(function (PLAYER_STATUS) {
    PLAYER_STATUS[PLAYER_STATUS["DEFAULT"] = -1] = "DEFAULT";
    PLAYER_STATUS[PLAYER_STATUS["FINISHED"] = 0] = "FINISHED";
    PLAYER_STATUS[PLAYER_STATUS["PLAYING"] = 1] = "PLAYING";
    PLAYER_STATUS[PLAYER_STATUS["PAUSE"] = 2] = "PAUSE";
    PLAYER_STATUS[PLAYER_STATUS["BUFFERING"] = 3] = "BUFFERING";
})(PLAYER_STATUS || (PLAYER_STATUS = {}));
export var DIRECTION;
(function (DIRECTION) {
    DIRECTION[DIRECTION["DOWN"] = 0] = "DOWN";
    DIRECTION[DIRECTION["UP"] = 1] = "UP";
})(DIRECTION || (DIRECTION = {}));
